$(document).ready(() => {
  $('#survey_analysis_button').on('click', (e) => {
    e.preventDefault();
    window.location.href = $('#survey_analysis_option').val();
  });
});
